// TODO: This is a temp component to inject properties in to redux while we slowly refactor it out
export default () => null;
